import { useQuery } from '@tanstack/react-query';

import useAccessBadge, { LicenseCoarseLevels } from './useAccessBadge';
import backendService from '../services/backendService';
import { TeachingCreditState } from '../services/backendService/backendService';

const getTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'America/Chicago';
  }
};

export const teachingCreditStateKey = ['teachingCreditState'];

const useTeachingCreditState = () => {
  const { accessBadge, isFetched: isBadgeFetched } = useAccessBadge();

  const isFreemium =
  isBadgeFetched &&
    accessBadge?.license?.coarseLevel === LicenseCoarseLevels.freemium;

  const { data: creditState, isLoading } = useQuery({
    queryKey: teachingCreditStateKey,
    queryFn: () => backendService.instance.users.getTeachingCreditState(getTimezone()),
    refetchInterval: 1000 * 60 * 5,
    staleTime: 1000 * 60,
    enabled: isFreemium,
  });

  if (!isFreemium) {
    return {
      creditState: undefined,
      isLoading: false,
      hasReachedLimit: false,
      remaining: Infinity,
      isEnabled: false,
    };
  }

  return {
    creditState,
    isLoading,
    hasReachedLimit: creditState?.hasReachedLimit,
    remaining: creditState?.remaining,
    isEnabled: true,
  };
};

export default useTeachingCreditState;
export type { TeachingCreditState };
